<template>
  <el-dialog v-loading="loading" append-to-body
             title="Создание значения списка"
             :visible.sync="dialogObject"
             @close="close"
             custom-class="add-jobs-dialog">

    <strong style="color: black">Название</strong>
    <el-input style="margin-top: 4px" v-model="form.value" @input="(e) => form.label = form.value"/>
    <div v-if="input">
      <div v-show="name" v-for="[key, name] in Object.entries(input.labels)" :key="key" style="margin-top: 10px">
        <template v-if="isShow(key)">
          <unit-select
            v-if="(key == 1 && (type.includes('materials') || type.includes('constructions') || type.includes('nomenclature')))"
            v-model="form.details[key]"/>
          <unit-select label="Ед. изм. 2"
                       v-else-if="(key == 3 && (type.includes('constructions') || type.includes('nomenclature')))"
                       v-model="form.details[key]"/>
          <div v-else>
            <strong style="color: black">{{ name }}</strong>
            <el-input
              :type="((type.includes('constructions') && (key == 2 || key == 4)) || (type.includes('materials') && Number(key) === 2)) ? 'number': 'string'"
              v-model="form.details[key]"
              style="margin-top: 4px"
            >
            </el-input>
          </div>
        </template>
      </div>
    </div>

    <div style="display: flex; justify-content: flex-end; margin-top: 20px">
      <el-button
        style="margin-left: 0; padding: 12px 8px"
        type="primary"
        @click="save"
      >Сохранить
      </el-button>
      <el-button style="margin-left: 10px; padding: 12px 8px"
                 @click="close">Закрыть
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {v4 as uuidv4} from 'uuid';
import firebase from "firebase";
import UnitSelect from "../../components/unitSelect";
import {addOptionsInputs} from "../../../../firestore/inputs";
import {isObject} from "lodash";

export default {
  name: "AddNewOption",
  components: {UnitSelect},
  props: {
    notActive: {
      type: Object,
      default: () => ({})
    },
    zoneId: String,
  },
  data() {
    return {
      dialogObject: false,
      input: null,
      loading: false,
      type: null,
      form: {
        label: '',
        value: '',
        uid: null,
        details: {}
      }
    }
  },
  watch: {},
  methods: {
    isShow(key) {
      if (key != 1 && key != 3 && key != 2 && key != 4) {
        return true
      }

      if ((key == 2 || key == 4) && this.input.withoutPlan) {
        return false
      }

      if (!this.input.type.includes('nomenclature')) {
        return true
      }

      if (key == 1 || key == 2) {
        if (this.input.type.includes('nomenclature') && this.input.withoutPlan && key == 2 && !this.notActive[1]) {
          return false
        }

        return !!this.notActive[1]
      }

      if (key == 3 || key == 4) {
        if (this.input.type.includes('nomenclature') && this.input.withoutPlan && key == 4 && !this.notActive[2]) {
          return false
        }


        return !!this.notActive[2]
      }
    },
    async save() {
      this.loading = true;
      const id = JSON.parse(JSON.stringify(this.input)).id
      delete this.input.id


      if (this.input.type.includes('L') || this.input.type.includes('nomenclature')) {
        if (this.zoneId) {
          this.form.zoneId = this.zoneId;
        }
        await addOptionsInputs(this.$store.state.project.id, id, [{...this.form, index: 99999999}])

        const resp = await firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inputs')
          .doc(id)
          .collection('optionsList')
          .limit(100).get()

        const result = []
        resp.forEach((d) => {
          result.push(
            {
              id: d.id,
              ...d.data(),
            }
          )
        })

        const optIndex = result.findIndex(({value}) => value === this.form.value)

        if (optIndex !== -1) {
          result.splice(optIndex, 1)
        }

        this.$emit('new-option', {
          ...this.input,
          options: [
            ...result,
            {...this.form}
          ]
        }, id, {...this.form})

        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Новое поле добавлено',
          type: 'success',
        });
        this.close()
        this.loading = false;
        return
      }

      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inputs').doc(id)
        .update({
          ...this.input,
          type: {
            label: this.input.value,
            value: this.input.type
          },
          options: this.input.type.includes('L') ? null : [
            ...this.input.options.map((option) => {
              return {
                ...option,
                label: option.value,
              }
            }),
            this.form
          ]
        }).then((add) => {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Новое поле добавлено',
          type: 'success',
        });

        this.$emit('new-option', {
          ...this.input,
          options: [
            ...this.input.options,
            this.form
          ]
        }, id, {
          ...this.form
        })

        this.close()

      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    close() {
      this.dialogObject = false
      this.input = null
      this.type = null
      this.form = {
        label: '',
        value: '',
        uid: null,
        details: {}
      }
    },
    open({data, name, zone}) {
      this.input = {...data, value: null}
      this.form.name = name;
      this.type = data.type

      let details = {
        1: data.defaultFields[1] || '',
        2: data.defaultFields[2] || '',
        3: data.defaultFields[3] || '',
        4: data.defaultFields[4] || '',
        5: data.defaultFields[5] || ''
      }

      if (data.type.includes('nomenclature')) {
        details = {
          1: data.defaultFields["1"] || '',
          2: data.defaultFields["2"] || '',
          3: data.defaultFields["3"] || '',
          4: data.defaultFields["4"] || '',
          5: data.defaultFields["5"] || '',
          6: data.defaultFields["6"] || '',
          7: data.defaultFields["7"] || '',
          8: data.defaultFields["8"] || '',
          9: data.defaultFields["9"] || '',
          10: data.defaultFields["10"] || ''
        }
      }

      try {
        this.form = {
          label: name,
          value: name,
          uid: uuidv4(),
          zoneId: data.type.includes('materials') || data.type.includes('constructions') || data.type.includes('multiple') ? zone && (zone.value === 'all' ? null : zone.value) : null,
          isZone: data.type.includes('materials') || data.type.includes('constructions') || data.type.includes('multiple') ? !!(zone && (zone.value === 'all' ? null : zone.value)) : null,
          details: details
        }
      } catch (e) {
        this.form = {
          label: name,
          value: name,
          uid: uuidv4(),
          zoneId: null,
          isZone: null,
          details: details
        }
      }

      this.dialogObject = true



      if (this.input.type.includes('multipleL')) {
        if(isObject(this.form.details[1])) {
          this.form.details[1] = ''
        }

      }

      if (this.input.type.includes('multipleL')) {
        if(isObject(this.form.details[3])) {
          this.form.details[3] = ''
        }
      }

      this.form = {...this.form}
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/components/AddNewOption.vue